export const algoliaIndexMixin = {
    methods: {
        getAlgoliaIndexName() {
          return process.env.VUE_APP_ALGOLIA_INDEX_NAME;
        },
    }
}